import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=6b63c518&scoped=true"
import script from "./MyInfo.vue?vue&type=script&lang=js"
export * from "./MyInfo.vue?vue&type=script&lang=js"
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=6b63c518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63c518",
  null
  
)

export default component.exports